<template>
  <ContentSection
    spacing="none"
    :class="conditionalSpacing"
  >
    <Container indent="lg">
      <div class="max-w-container-max">
        <figure>
          <AppImage
            v-if="data.image"
            :src="data.image"
            :alt="useMapAltText(data.image)"
            class="h-full max-h-[60vh] object-contain"
            :class="data.position?.value === 'center' ? 'object-center' : 'object-left'"
          />

          <figcaption
            class="mt-2"
            :class="data.position?.value === 'center' ? 'text-center' : `text-left`"
          >
            <span
              v-if="data.caption"
              class="typo-body-md sm:typo-body-lg"
            >{{ data.caption }}</span>
          </figcaption>
        </figure>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { ComponentsBrBrImageFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsBrBrImageFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
)
</script>
